export default {
  dashboard: "Dashboard",
  admins: "Admins",
  admin_create: "Create",
  admins_list: "List admins",
  students: "students",
  students_create: "Create",
  students_list: "List students",
  customers: "Customers",
  products_section: "Products Management",
  product_categories: "Product Categories",
  products: "Products",
  add_products: "Add Product",
  orders_section: "Order Management",
  shipping_methods: "Shipping Methods",
  orders: "Orders",
  add_order: "Add order",
  invoices: "Invoices",
  paymentMethods: "Payment Methods",
  base_definition:"Master Data",
  address_list:"list address"

}

